class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      
      if (section.id === "cart-icon-bubble") {
        document.querySelectorAll("a#cart-icon-bubble").forEach((element) => {
          let html = new DOMParser()
          .parseFromString(parsedState.sections[section.id], "text/html");
          let cart_bubble = html.querySelector(".js-cart-bubble");
          element.querySelector(".js-cart-bubble").innerHTML =
            cart_bubble.innerHTML;
        });
      } else {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartSample extends HTMLElement {
  constructor() {
    super();

    this.maxSelection = this.dataset.maxSelection ? parseInt(this.dataset.maxSelection, 10) : 1;
    this.selectedProducts = [];
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.querySelector(".closeCartSlider").addEventListener("click", this.closeSlider.bind(this))
    this.querySelectorAll(".sample-grid-item").forEach((element) => {
      element.addEventListener("click", this.handleSelection.bind(this))
    });
    this.querySelector("#sample-confirm").addEventListener("click", this.handleSubmit.bind(this));
    this.querySelector("#sample-confirm").disabled = true;
    // console.log(this.cart)
    // console.log("itemns", this.cart.querySelector("cart-drawer-items"))
    this.cartSampleItem;
    // this.cartSampleItemIndex;
    // console.log("this.cartSampleItemIndex", this.cartSampleItemIndex)
    this.loadCartGiftItems()
  }

  closeSlider() {
    this.querySelector(".menu-opening").removeAttribute("open")
  }

  getSelectedProducts() {
    let selectedProducts = [];
    this.querySelectorAll(".sample-grid-item .sample-item-checkbox:checked").forEach((item) => {
      selectedProducts.push(item.value)
    })

    return selectedProducts;
  }

  handleSelection(event) {
    let selectedProducts = this.getSelectedProducts();
    if (selectedProducts.length >= this.maxSelection) {
      this.querySelectorAll(".sample-grid-item .sample-item-checkbox").forEach((item) => {
        // console.log(item)
        if (item.id !== event.target.id) {
          item.checked = false
        }
      })
    }

    this.querySelector(".sampleLimit").innerText = this.querySelectorAll(".sample-grid-item .sample-item-checkbox:checked").length;
    this.querySelector("#sample-confirm").disabled = this.cartSampleItem === event.target.value ? true: false;
  }

  handleSubmit(event) {
    let selectedProducts = this.getSelectedProducts()
    // console.log(selectedProducts, this.cartSampleItem)

    let updates = {
      [selectedProducts[0]]: 1
    }

    if(this.cartSampleItem){
      updates[this.cartSampleItem] = 0
    }

    this.updateCart(updates)
  }

  updateCart(updates){
    let config = {
      method: 'POST',
      headers: {  'Content-Type': 'application/json', Accept: `application/json` },
      body: JSON.stringify({ updates }),
    }

    fetch(`${routes.cart_update_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      // console.log(response)
      let selectedProducts = this.getSelectedProducts();
      let item = response.items.find((e) => e.variant_id.toString() === selectedProducts[0])
      const cartGiftItem = this.cart.querySelector("#cartGiftItem");
      if(this.cartSampleItem){
        cartGiftItem.querySelector(`.giftList[data-id='${this.cartSampleItem}']`).remove();
      }
      
      cartGiftItem.innerHTML = cartGiftItem.innerHTML + `
        <div class="giftList" data-id="${item.variant_id}">
        <div class="gift-detail">
          <p>${item.title}</p>
          <span>무료</span>
        </div>
        <div class="gift-image">
          <img src="${item.featured_image.url}?crop=center&amp;height=120&amp;v=1716181652&amp;width=120 120w" width="120" height="120">
        </div>
      </div>
      `
      this.loadCartGiftItems()

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-drawer',
        productVariantId: selectedProducts[0],
        cartData: response,
      });
      // alert('added successfully');
      this.closeSlider()
    })
  }

  loadCartGiftItems(){
    this.cart.querySelectorAll('#cartGiftItem .giftList').forEach((cartGiftItem) => {
      let sampleItem = this.querySelector(`.sample-grid-item[data-id='${cartGiftItem.dataset.id}']`);
      if(sampleItem){
        this.cartSampleItem = cartGiftItem.dataset.id;
        this.querySelector("#sample-confirm").disabled = true;
        let element = sampleItem.querySelector(".sample-item-checkbox");
        element.checked = true;
        const event = new Event("change", { bubbles: true });
        element.dispatchEvent(event);
      }
    })
  }
}

customElements.define('cart-sample', CartSample);
